import React, { Component } from 'react'

// Online / Offline pill for the top navbar, driven by the browser's
// online/offline events.
class NetworkStatus extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isOnline: typeof navigator !== "undefined" && navigator.onLine !== undefined ? navigator.onLine : true,
        }
    }

    componentDidMount() {
        window.addEventListener("online", this.handleConnectionChange);
        window.addEventListener("offline", this.handleConnectionChange);
    }

    componentWillUnmount() {
        window.removeEventListener("online", this.handleConnectionChange);
        window.removeEventListener("offline", this.handleConnectionChange);
    }

    handleConnectionChange = () => {
        this.setState({ isOnline: navigator.onLine });
    }

    render() {
        const { isOnline } = this.state;
        return (
            <div className="network-status d-flex align-items-center mr-3">
                <span className={`network-pill ${isOnline ? 'is-online' : 'is-offline'}`} role="status">
                    <i className={isOnline ? "fas fa-wifi" : "fas fa-wifi-slash"} />
                    <span className="network-label">{isOnline ? "Online" : "Offline"}</span>
                </span>
            </div>
        )
    }
}

export default NetworkStatus
